<template>
    <div class="marginCon">
        <Card>
    
            <div v-if="offModel">

                 <div class="top" >
                    <Button type="success" class="addButton"  @click="addData(1)" style="margin-right:8px;">{{$t("firmwarePlan.addButton")}}</Button>
                </div>

                <Table style="width: 100%;margin-top: 30px;" :columns="titleName" :data="tableList.tableData"  ref="selection" @on-sort-change="sortCustom" :loading='loading'></Table>
                <Page @on-change="changePage" @on-page-size-change="changeSize" :total="page.total" show-sizer :show-total="true" :current="page.current" :page-size="page.pageSize" :page-size-opts="[10,15,20]" placement="top" class="pages"/>
            </div>

            <!-- 更改状态弹框组件 -->
            <ChangeDialog ref="changeChild" @ievent = "ievent(1)" :title='$t("firmwareVersion.changeTitle")' :cont='$t("firmwareVersion.changeCont")'></ChangeDialog>

            <!-- 编辑 / 添加  模态框组件 -->
            <ModelBox :showModel.sync="addBox.showModel" :offModel.sync='offModel' :fn="addBox.callbackFn" :type="type" :editFormData="addBox.editFormData"></ModelBox>

            <!-- 删除弹框组件 -->
            <ChangeDialog ref="deleteChild" @ievent = "ievent(2)"  :title='$t("orderManage.deletModel.changeTitle")' :cont='$t("orderManage.deletModel.changeCont")'></ChangeDialog>

        </Card>
    </div>
</template>

<script>

import common from '@/common/common.js';
import ChangeDialog from '../common/deleteModel.vue'; // 引入删除弹框组件
import ModelBox from './component/planAddModel.vue';
import moment from 'moment'; // 引入删除弹框组件
import { mapState } from 'vuex'

    export default {
        name: "firmwareVersion",
        components: {
            ChangeDialog,
            ModelBox
        },
        data(){
            return{
                type:1,
                loading: true,
                offModel: true,
                paging:true,//后端是否做了分页
                page:{//分页排序
                    total:0,//总条数
                    pageSize:15,//每页条数
                    current:1,//当前页
                    key:'id',
                    order:'desc'
                },
                addBox:{//规格弹框组-新增
                    showModel:false,//弹框开关
                    callbackFn:()=>{}, //弹框的回调函数
                    editFormData:{},//编辑时传入的现有数据
                },
                tableList:{
                    tableData:[],
                    tableDataAll:[],
                    hasSelectData:{}
                },
                
               
            }
        },
        computed:{
           ...mapState(['local','selectId']),
            roleType(){
	        	let res = '2'
	        	if(this.$store.state.uInfo && this.$store.state.uInfo.roleType){
	        	 res = this.$store.state.uInfo.roleType
	        	}
	        	return res
	        },
            titleName(){
               return [
                    {
                        title:this.$t('firmwarePlan.titleName.id'),
                        key: 'id',
                        width: 120,
                        sortable: true,
                        tree: true
                    },
                    {
                        title:this.$t('firmwarePlan.titleName.createTime'),
                        key: 'createTime',
                        width: 110,
                         render:(h, params)=>{
                            let stext = moment(params.row.createTime*1).format('YYYY-MM-DD')
                             return h('div',stext || '')
                        }
                    },
                    {
                        title:this.$t('firmwarePlan.titleName.fwareId'),
                        key: 'fwareId',
                        width: 120
                    },
                    {
                        title:this.$t('firmwarePlan.titleName.fwareVersion'),
                        key: 'fwareVersion',
                        width: 200
                    },
                    {
                        title:this.$t('firmwarePlan.titleName.deviceGroupName'),
                        key: 'deviceGroupName',
                        minWidth: 160,
                        render:(h,params)=>{
                            let stext = ''
                            stext = params.row.releaseForAllSuitype?this.$t('firmwarePlan.allGroup'):params.row.deviceGroupName
                            return h('div',stext)
                        }
                    },

                    {
                        title:this.$t('firmwarePlan.titleName.number'),
                        key: 'limitSize',
                        width: 140
                    },
                    {
                        title:this.$t('firmwarePlan.titleName.unit'),
                        key: 'intervalUnit',
                        width: 130,
                        render:(h,params)=>{
                            let obj ={'1':this.$t('selectList.timeUnit.month'),'2':this.$t('selectList.timeUnit.day'),'3':this.$t('selectList.timeUnit.hour'),'4':this.$t('selectList.timeUnit.minute'),'5':this.$t('selectList.timeUnit.second')}
                            let stext = ''
                            stext = obj[params.row.intervalUnit] || ''
                            return h('div',stext)
                        }
                    },
                    {
                        title:this.$t('firmwarePlan.titleName.interval'),
                        key: 'pushInterval',
                        width: 130,
                       
                    },
                    // {
                    //     title:this.$t('firmwarePlan.titleName.minNumber'),
                    //     key: 'pushInterval',
                    //     width: 130,
                       
                    // },
                   
                    {
                        title:this.$t('firmwarePlan.titleName.updateDevices'),
                        key: 'updateDevices',
                        width: 130
                    },
                    {
                        title:this.$t('firmwarePlan.titleName.whetherRun'),
                        key: 'whetherRun',
                        width: 120
                    },
                    {
					    title:this.$t('firmwarePlan.titleName.Operation'),
					    minWidth:this.roleType==1?160:110,
                        key: "Operation",
                        // fixed:'right',
					    render: (h, params) => {
                            let that = this
                           
                            return [
                                   h('div',
                                       { 
                                        style:{
                                            display: "flex",
                                            justifyContent:'center'
                                            }
                                        },[
                                            h('Button', {
					                            props: {
                                                    type: "error",
                                                    size: 'small'
                                                },
                                                style:{
                                                    'margin-right':'5px',
                                                    'display':this.roleType==1?'block':'none'
                                                },
					                            on: {
					                                click: () => { this.changeStatus(params.row,'deleteChild') }
					                            }
					                        }, that.$t("delete")),
                                            h('Button', {
					                            props: {
                                                    type: "info",
                                                    size: 'small'
                                                },
                                                style:{
                                                    'margin-right':'5px',
                                                    // 'display':this.roleType==1?'block':'none'
                                                },
					                            on: {
					                                click: () => { this.addData(2,params.row) }
					                            }
					                        }, that.$t("edit")),
                                            h('Button', {
					                            props: {
                                                    type: params.row.whetherRun?"warning":"primary",
                                                    size: 'small'
                                                },
                                                style:{
                                                },
					                            on: {
					                                click: () => { this.changeStatus(params.row,'changeChild') }
					                            }
					                        }, params.row.whetherRun?that.$t("firmwareVersion.stop"):that.$t("firmwareVersion.start"))
                                         ]
                                    )
                                ]
					    }
					}
                ]
            },
           
        },
        created (){
          
            this.getData()
        },
    
        methods: {
            addData(type,item={}) {  //添加或编辑数据
                // if(this.roleType==2) return
                this.addBox.showModel = true
                this.offModel = false
                this.type = type
                if(type == 2) {
                    this.addBox.editFormData = item
                }
                this.addBox.callbackFn = () => {//回调处理
                    //重新载入
                    // this.clearbtnStatus()
                    this.addBox.showModel = false;
                    this.getData();
                }
            },
            changeStatus(item,type){//更改状态，删除计划
                this.tableList.hasSelectData = item;
                this.$refs[type].showit();

            },
            ievent(type) {// 更改状态，删除计划
                // console.log('更改状态',this.tableList.hasSelectData.id)
                if(type==1){
                    let getData = {
                        id: this.tableList.hasSelectData.id,
                        whetherRun: !this.tableList.hasSelectData.whetherRun,
                        dealerId:this.selectId
                    }
                    // console.log(getData)
                    this.axios.post(this.config.urlArray.fwareplansRun, getData).then((result)=>{
                        common.ajaxMsg(result.data,true,()=>{
                            this.$refs.changeChild.recancel();
                            this.getData();
                        })
                    }).catch((err)=>{
                        // common.msg('error','删除失败')
                    })
                }else if(type==2){

                    if(this.roleType==2) return
                    this.axios.post(this.config.urlArray.fwareplansDel, {id:this.tableList.hasSelectData.id}).then((result)=>{
                        common.ajaxMsg(result.data,true,()=>{
                            this.$refs.deleteChild.recancel();
                            this.getData();
                        })
                    }).catch((err)=>{
                        // common.msg('error','删除失败')
                    })

                }
                
            },
            searchItem(){

            },
           
            getData(){ //获取数据
                let getData = {
                    params:{
                        page:this.page.current,
                        limit:this.page.pageSize,
                        sort:this.page.key,
                        asc:this.page.order,
                        dealerId:this.selectId
                    }
                }
                this.axios.post(this.config.urlArray.fwareplansList,getData.params).then((result) => {
                    common.ajaxMsg(result.data,false,()=>{

                        let resData = result.data.data
                        //处理数组
                        if(resData){
                            this.tableList.tableDataAll  =  resData
    
                            if(!resData.meta){//分页不生效
                                this.paging = false
                                this.page.total = result.data.data.length
                                this.getData1()
                            }else{
                                this.tableList.tableData = resData
                                this.page.total = resData.meta.count
                            }
                            
                            this.loading = false
                        }else{
                            this.tableList.tableData = []
                            this.page.total = 0
                            this.loading = false
                            return false
                        }
                    });
                }).catch((err) => {
                    // common.msg('error','获取失败',()=>{})
                });
            },
             getData1(){
                let start = (this.page.current-1)*this.page.pageSize
                let end = (this.page.current)*this.page.pageSize
                let key =  this.page.key
                let order = this.page.order

                this.tableList.tableDataAll = this.tableList.tableDataAll.sort((a,b)=>{
                    if(order=='asc'){
                       return a[key]-b[key]
                    }else if(order=='desc'){
                        return b[key]-a[key]
                    }
                    
                })

                this.page.total = this.tableList.tableDataAll.length
                
                this.tableList.tableData = this.tableList.tableDataAll.slice(start,end)

            },
            sortCustom (data) {//自定义排序
                this.page.key = data.key
                this.page.order = data.order
                if(this.paging){
                    this.getData()          
                }else{
                    this.getData1()  
                }
            },
            changePage (nowpage) {//切换分页
                this.page.current = nowpage
                if(this.paging){
                    this.getData()          
                }else{
                    this.getData1()  
                }
            },
            changeSize (nowSize) {//切换每页显示条数
                this.page.pageSize = nowSize
                this.page.current = 1
                if(this.paging){
                    this.getData()          
                }else{
                    this.getData1()  
                }
            }
        }
    }
</script>



